import { HeaderSearchRecord } from 'src/contracts/headerSearch';
import {
  ACCESS_LEVEL_PAGES,
  PAGE_TITLES
} from 'src/workspaces/companyProfilePageAccess';
import {
  companyWorkspacePath,
  TenantWorkspaceRouteScope
} from 'src/workspaces/tenantWorkspace';

type SearchScope = TenantWorkspaceRouteScope & {
  role?: string;
  accessLevel?: string | null;
  accessLevels?: readonly string[] | null;
};
export const searchAccessLevels = (scope: SearchScope) =>
  scope.accessLevels?.length
    ? scope.accessLevels
    : [scope.accessLevel ?? scope.role ?? ''];

// Parameter-dependent pages and aliases are reached through their canonical page.
const FEATURE_PAGES = [
  'overview',
  'settings',
  'job-listing-defaults',
  'table-formatting',
  'insurance',
  'users-permissions',
  'email-templates',
  'client-agreements',
  'client-profiles',
  'positions',
  'dress-codes',
  'tax-forms',
  'employee-contracts',
  'worker-insurance',
  '1099-records'
];
const ALIASES: Record<string, string> = {
  'tax-forms': 'tax w9 w-9 i9 i-9',
  '1099-records': 'tax 1099',
  'employee-contracts': 'worker agreements payroll settings rate types',
  positions: 'positions job roles'
};
export function searchFeatures(scope: SearchScope, query: string) {
  const normalized = query.trim().toLowerCase();
  if (normalized.length < 2) return [];
  const levels = searchAccessLevels(scope);
  return FEATURE_PAGES.filter(
    (page) =>
      PAGE_TITLES[page] &&
      (scope.role === 'SUPER_ADMIN' ||
        levels.some((level) => ACCESS_LEVEL_PAGES[level]?.has(page))) &&
      `${PAGE_TITLES[page]} ${ALIASES[page] ?? ''}`
        .toLowerCase()
        .includes(normalized)
  ).map((page) => ({
    id: page,
    title: PAGE_TITLES[page],
    to: companyWorkspacePath(scope, `profile/${page}`)
  }));
}

export function recordDestination(
  scope: SearchScope,
  record: HeaderSearchRecord
) {
  if (record.kind === 'document') {
    return `${companyWorkspacePath(
      scope,
      `profile/client-profiles/${record.clientId}/${
        record.section ?? 'documents'
      }`
    )}?documentId=${record.id}`;
  }
  const tab =
    record.kind === 'invoice'
      ? 'client-invoice'
      : record.kind === 'quote'
      ? 'quote'
      : 'bookings';
  return `/dashboards/jobTracker/positions/${record.eventId}?tab=${tab}`;
}
export const recordDestinationLabel = {
  event: 'Bookings',
  quote: 'Quote',
  invoice: 'Client Invoice',
  document: 'Documents'
};
